import axios, { AxiosRequestConfig } from "axios";
import { buscaFabricante, updateFabricanteBusca } from "../types/fabicante";

export const getFabricantes = async (token: string): Promise<buscaFabricante[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/fabricante`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar fabricantes:", error);
    throw error;
  }
};

export const getFabricanteById = async (
  token: string,
  id: string
): Promise<buscaFabricante> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/fabricante/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar fabricante:", error);
    throw error;
  }
};

export const createFabricante = async (token: string, fabricanteData: FormData) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/fabricante`;
    const response = await axios.post(url, fabricanteData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar fabricante:", error);
    throw error;
  }
};

export const updateFabricante = async (
  token: string,
  id: string,
  fabricanteData: updateFabricanteBusca
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/fabricante/${id}`;
    const response = await axios.put(url, fabricanteData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar fabricante:", error);
    throw error;
  }
};

export const deleteFabricante = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/fabricante/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir fabricante:", error);
    throw error;
  }
};